import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/images/logo1.png'


const _hoisted_1 = { class: "candidateWebPage" }
const _hoisted_2 = { class: "refereeeIntro" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Logezy Reference ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = { class: "hedStatus" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Completed ")
const _hoisted_7 = { style: {"margin":"0 15px 0 10px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Pending ")
const _hoisted_9 = { style: {"background-color":"#ffcc00"} }
const _hoisted_10 = { class: "head" }
const _hoisted_11 = { class: "copuUrlSec" }
const _hoisted_12 = { class: "url" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Copy Url")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "subline" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" The following referees are currently being processed by ")
const _hoisted_18 = {
  key: 1,
  class: "refereeLists"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, " Referee Name / Relationship / Email ", -1)
const _hoisted_20 = { class: "body" }
const _hoisted_21 = { style: {"font-weight":"400"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Dates / Company / Job Title", -1)
const _hoisted_23 = { class: "body" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "refExtra" }
const _hoisted_27 = {
  key: 0,
  class: "refStatus"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Reference Completed ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Send Reminder ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_31 = {
  key: 3,
  class: "refStatus"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Pending ")
const _hoisted_33 = {
  key: 4,
  class: "refStatus"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Reminded ")
const _hoisted_35 = {
  key: 2,
  class: "addnewRef"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "addref-btn" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Add Referee ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Reached the maximum add referee limit")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Add Referees ")
const _hoisted_41 = { class: "addReferpage" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", null, "Add Referee", -1)
const _hoisted_43 = {
  key: 1,
  class: "content expiredCnt"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "texts",
  style: {"text-align":"center"}
}, " The page is expired! ", -1)
const _hoisted_45 = { class: "complete-btn" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" You may close this window ")
const _hoisted_47 = {
  key: 0,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_BellOutlined = _resolveComponent("BellOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_ClockCircleOutlined = _resolveComponent("ClockCircleOutlined")!
  const _component_ClockCircleFilled = _resolveComponent("ClockCircleFilled")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_addNewRefereeModal = _resolveComponent("addNewRefereeModal")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          sm: 24,
          md: 20,
          lg: 16,
          xl: 12,
          style: {"margin":"auto"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.candidateDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_a_collapse, {
                      activeKey: _ctx.activeKey,
                      "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeKey) = $event)),
                      accordion: "",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tabChanged(_ctx.activeKey)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_collapse_panel, {
                          key: "1",
                          header: "Referees",
                          class: _normalizeClass(["firstheader", _ctx.addReferee === true ? 'showfirstheader' : ''])
                        }, {
                          extra: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _hoisted_6,
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getCount("approved")), 1),
                              _hoisted_8,
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getCount("pending")), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("h2", null, "Hi " + _toDisplayString(_ctx.candidateDetails?.candidate_name) + ",", 1),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("input", {
                                    onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select())),
                                    ref: "clone",
                                    readonly: "",
                                    value: _ctx.copyUrl
                                  }, null, 40, _hoisted_13)
                                ]),
                                _createVNode(_component_a_tooltip, null, {
                                  title: _withCtx(() => [
                                    _hoisted_14
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: "copy",
                                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
                                    }, [
                                      _createVNode(_component_CopyOutlined)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _hoisted_15,
                            (_ctx.candidateDetails?.referees.length)
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_16, [
                                  _hoisted_17,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.candidateDetails?.agency_name) + " :", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.candidateDetails?.referees)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidateDetails.referees, (referess) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: referess.id
                                    }, [
                                      _createVNode(_component_a_row, {
                                        gutter: 2,
                                        class: _normalizeClass(["singlerefere", 
                        referess.status === 'pending'
                          ? 'pending'
                          : referess.status === 'completed'
                          ? 'completed'
                          : referess.status === 'reminded'
                          ? 'reminded'
                          : ''
                      ])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            xs: 24,
                                            sm: 24,
                                            md: 12,
                                            class: "left"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_19,
                                              _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("ul", null, [
                                                  _createElementVNode("li", _hoisted_21, _toDisplayString(referess.referee_name), 1),
                                                  _createElementVNode("li", null, _toDisplayString(referess.referee_relationship), 1),
                                                  _createElementVNode("li", null, _toDisplayString(referess.email), 1)
                                                ])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_a_col, {
                                            xs: 24,
                                            sm: 24,
                                            md: 12,
                                            class: "right"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_22,
                                              _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("ul", null, [
                                                  _createElementVNode("li", null, [
                                                    _createTextVNode(_toDisplayString(_ctx.moment(
                                  referess.work_start,
                                  "YYYY-MM-DD"
                                ).format("MMM YYYY")) + " to ", 1),
                                                    (referess.work_end)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.moment(referess.work_end, "YYYY-MM-DD").format("MMMM YYYY")), 1))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, "Present"))
                                                  ]),
                                                  _createElementVNode("li", null, _toDisplayString(referess.company), 1),
                                                  _createElementVNode("li", null, _toDisplayString(referess.candidate_job), 1)
                                                ])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createElementVNode("div", _hoisted_26, [
                                            (referess.status === 'completed')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                  _createVNode(_component_CheckCircleFilled),
                                                  _hoisted_28
                                                ]))
                                              : _createCommentVNode("", true),
                                            (
                            referess.status === 'pending' ||
                            referess.status === 'reminded'
                          )
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 1,
                                                  type: "primary",
                                                  block: "",
                                                  class: "remainder-btn",
                                                  loading: _ctx.refereRemainderLoading,
                                                  onClick: ($event: any) => (_ctx.sendRefereeRemindar(referess))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_29,
                                                    _createVNode(_component_BellOutlined)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "onClick"]))
                                              : _createCommentVNode("", true),
                                            (
                            referess.status === 'pending' ||
                            referess.status === 'reminded'
                          )
                                              ? (_openBlock(), _createBlock(_component_a_button, {
                                                  key: 2,
                                                  type: "primary",
                                                  block: "",
                                                  class: "delete-btn",
                                                  onClick: ($event: any) => (_ctx.showDeleteConfirm(referess)),
                                                  loading: _ctx.deleteRefereLoading
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_30,
                                                    _createVNode(_component_DeleteOutlined)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick", "loading"]))
                                              : _createCommentVNode("", true),
                                            (referess.status === 'pending')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                  _createVNode(_component_ClockCircleOutlined),
                                                  _hoisted_32
                                                ]))
                                              : _createCommentVNode("", true),
                                            (referess.status === 'reminded')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                  _createVNode(_component_ClockCircleFilled),
                                                  _hoisted_34
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.candidateDetails)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  (
                        _ctx.candidateDetails.referees.length <
                        _ctx.candidateDetails.reference_required
                      )
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_36, " To complete this reference request, you must provide " + _toDisplayString(_ctx.candidateDetails.reference_required - _ctx.candidateDetails.referees.length) + " additional referee not already listed above. ", 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_37, [
                                    (
                        _ctx.candidateDetails.referees.length <
                        _ctx.candidateDetails.referee_add_count
                      )
                                      ? (_openBlock(), _createBlock(_component_a_button, {
                                          key: 0,
                                          type: "primary",
                                          size: "large",
                                          block: "",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNewReferee()))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_38
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_a_tooltip, {
                                          key: 1,
                                          class: "ttip"
                                        }, {
                                          title: _withCtx(() => [
                                            _hoisted_39
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_button, {
                                              type: "primary",
                                              size: "large",
                                              block: "",
                                              disabled: true
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_40
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.addReferee)
                          ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                              key: "2",
                              class: "secondheader"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_41, [
                                  _hoisted_42,
                                  _createVNode(_component_addNewRefereeModal, {
                                    From: 'candidatePage',
                                    candidateId: _ctx.candidateDetails.id,
                                    accessToken: _ctx.accessToken,
                                    onCloseRefereeModal: _ctx.refereeAdded
                                  }, null, 8, ["candidateId", "accessToken", "onCloseRefereeModal"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["activeKey"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "large",
                        block: "",
                        class: "closW",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closewindow()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      })
                    ])
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.pageLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}